// @generated by protoc-gen-es v1.10.0
// @generated from file penumbra/core/txhash/v1/txhash.proto (package penumbra.core.txhash.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * The hash of a Penumbra transaction's _effecting data_, describing the effects
 * of the transaction on the chain state.
 *
 * @generated from message penumbra.core.txhash.v1.EffectHash
 */
export const EffectHash = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.txhash.v1.EffectHash",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A transaction ID, the Sha256 hash of a transaction.
 *
 * This is the hash of the plain byte encoding, used by Tendermint.
 *
 * @generated from message penumbra.core.txhash.v1.TransactionId
 */
export const TransactionId = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.txhash.v1.TransactionId",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

